export default "__VITE_ASSET__BYcz4lLO__"